import React, { useEffect } from "react";
// import logo from './logo.svg';
import "select2/dist/css/select2.min.css";
import "select2";
import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";

import { Route, Routes, useNavigate, useLocation } from "react-router-dom";

import Login from "./components/Login";

import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import jwt_decode from "jwt-decode";
import { actionCreaters } from "./Redux";

import ProtectedRoute from "./components/Includes/ProtectedRoute";

import RegisteredUsers from "./components/RegisteredUsers";
import RegisteredUsersSand from "./components/RegisteredUsersSand";

function App() {
  const dispatch = useDispatch();
  const userActions = bindActionCreators(actionCreaters, dispatch);
  const navigate = useNavigate();
  const locat = useLocation();
  const state = useSelector((state) => state.stateVals);
  // const { state, dispatch: ctxDispatch } = useContext(UserContext);
  const { accessToken, role } = state;
  // console.log(`role=${role}}`);
  let decoded;

  useEffect(() => {
    if (accessToken) {
      decoded = jwt_decode(accessToken);
      // auto logout code start
      if (Math.floor(new Date().getTime() / 1000) > decoded.exp) {
        userActions.logOut(null);
        Swal.fire({
          title: "Expired!",
          text: "Your Login Session expired!",
          icon: "error",
          confirmButtonText: "Login Again",
        });
        navigate("/");
      } else if (locat.pathname === "/") {
        navigate("/registered-users/production");
      }
    } else {
      navigate("/");
    }
  }, [locat.pathname]);

  // TODO websites management
  return (
    <Routes>
      <Route path="/" element={<Login />} />

      <Route
        path="/registered-users/production"
        element={
          <ProtectedRoute roleArg={["city"]}>
            <RegisteredUsers />
          </ProtectedRoute>
        }
      />
      <Route
        path="/registered-users/sandBox"
        element={
          <ProtectedRoute roleArg={["city"]}>
            <RegisteredUsersSand />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default App;
